import React, { useState, useEffect } from 'react';
import { formatDate } from 'react-day-picker/moment';
import { DateTime } from 'luxon';

import Label from '../../../components/label';
import InputNumeral from '../../../components/input-numeral';
import TextNumber from '../../../components/text-number';
import ReportButton from '../../../components/report-button';
import DayPicker from '../../../components/day-picker';
import DisburseCheckbox from './disbursse-checkbox';
import LoaderType from '../../../components/loader-type';
import { getData, getFile } from '../../../helper/request-response';
import { downloadFile } from '../../../helper/util';
import constant from '../../../config/constant';
import cashoutPath from './config';

const List = () => {

    const [isLoad, setIsLoad] = useState(true);

    const [date, setDate] = useState(DateTime.local());

    const [cashout, setCashout] = useState([]);

    const [purchaseSummary, setPurchaseSummary] = useState({
        farmer: 0,
        total: 0,
        amount: 0 
    });

    const onDayChange = day => setDate(formatDate(day, constant.DEFAULT_DATE));

    const getPurchases = async(param, url) => await getData(url, param);

    const getExcel = async(param, url) => await getFile(url, param);

    const onExport = e => {

        e.preventDefault();

        const params = {
            params: { 
                'purchase-date': DateTime.fromISO(date).toFormat(constant.PARAM_DATE_FORMAT)
            }
        };

        getExcel(params, cashoutPath.palmoilCashoutPurchaseExcel).then(response => {

            downloadFile(response);

        });

    }

    const onReset = e => {

        e.preventDefault();

        setDate(DateTime.local());

    }

    useEffect(() => { 

        const populateCashout = () => {

            setIsLoad(true);

            const params = {
                params: { 
                    'purchase-date': DateTime.fromISO(date).toFormat(constant.PARAM_DATE_FORMAT)
                }
            };
    
            getPurchases(params, cashoutPath.palmoilCashoutSum).then(result => {
    
                setPurchaseSummary(sum => ({
                    ...sum,
                    farmer: result[0][0].totalFarmer,
                    total: result[0][0].totalKg,
                    amount: result[0][0].totalSales
                }));
    
            });
            
            getPurchases(params, cashoutPath.palmoilCashoutPurchase).then(result => {
    
                setCashout(result[0]);
                
                setIsLoad(false);
            });
    
        }

        populateCashout();
        
    }, [date]);

    return(
        <React.Fragment>
            <div className="card-header">
                <h3 className="h6 text-uppercase mb-0">{ cashoutPath.title }</h3>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-6 border-right">
                        <form className="form-horizontal" >
                            
                            <div className="form-group row">
                                <div className="col-md-12">
                                    <Label htmlFor="trx-date" text="Tanggal" />
                                    <DayPicker id="trx-date" name="trx-date" onDayChange={onDayChange} valueDate={ date } />
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-md-12">
                                    <ReportButton isSubmit={ false } onClick={ onReset } onExport={ onExport }/>
                                </div>
                            </div>
                        </form>
                    </div>
                    {
                        !isLoad &&
                        <div className="col-md-6">
                            <div className="form-group row">
                                <div className="col-md-12">
                                    <h3>Rekapitulasi {`${formatDate(date, 'LL', constant.LOCALE)}`}</h3>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md-12">
                                    <Label text="Jumlah Petani dan Agen" />
                                    <InputNumeral
                                        value={ purchaseSummary.farmer }
                                        display={ true }
                                    />
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-md-12">
                                    <Label text="Total Kilogram (Kg)" />
                                    <InputNumeral
                                        value={ purchaseSummary.total }
                                        display={ true }
                                    />
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-md-12">
                                    <Label text="Total Pembelian (Rp)" />
                                    <InputNumeral
                                        value={ purchaseSummary.amount }
                                        display={ true }
                                    />
                                </div>
                            </div>
                        </div>
                    }
                </div>

                {
                    isLoad &&
                    <LoaderType />
                }

                {
                    !isLoad && cashout.length > 0 &&
                    <>
                        <br />

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="table-responsive">
                                    <table className="table table-striped table-hover card-text">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Invoice</th>
                                                <th>Tipe Pelanggan</th>
                                                <th>Jalur</th>
                                                <th>Kode</th>
                                                <th>Nama</th>
                                                <th>Jumlah (Kg)</th>
                                                <th>Pembayaran (Rp)</th>
                                                <th>Pengambilan</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                cashout.map((co, index) => {
                                                    return(
                                                        <tr key={ index }>
                                                            <th scope="row">{ index + 1 }</th>
                                                            <td>{ co.invoiceNo }</td>
                                                            <td>{ co.customerType }</td>
                                                            <td>{ co.retribution }</td>
                                                            <td>{ co.customerCode }</td>
                                                            <td>{ co.customerName }</td>
                                                            <td><TextNumber value={ co.qty } /></td>
                                                            <td><TextNumber value={ co.payment } /></td>
                                                            <td><DisburseCheckbox cashout={ co }  /></td>
                                                        </tr>
                                                    );
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>
        </React.Fragment>
    );
};

export default List;
